import { configure, initialize } from "react-rb"
import { AppWrapper } from "../layout/app-wrapper"
import { loadPageComponent } from "bundler/load-page-component"

function setup() {
  initialize({ layout: AppWrapper })
  configure({ loadPageComponent })
}

if (document.readyState === "complete") {
  setup()
} else {
  document.addEventListener("DOMContentLoaded", setup)
}
